// extracted by mini-css-extract-plugin
export var section = "NotFound-module--section--fN4hd";
export var content = "NotFound-module--content--imZ-F";
export var button = "NotFound-module--button--2zZ4I";